import styles from "./styles/ImageLoadingTile.module.scss";

const ImageLoadingTile = (props) => {
  return <div id={props.id} className={styles.container}></div>;
};

export default ImageLoadingTile;
